import React from 'react'
import _ from 'lodash'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import {
  Card,
  ContentSectionBlock,
  Table
} from 'camino-react'

import 'moment/locale/en-gb'

import { cloudhelpDelete, cloudhelpGet } from 'Utilities/CloudHelp'
import Alert from 'Components/Alert'
import Row from 'Components/Row'
import Col from 'Components/Col'
import TimesheetModal from 'Components/Timesheets/TimesheetModal'
import AllTimesheetsModal from 'Components/Timesheets/AllTimesheetsModal'

const ActionsCell = ({
  row,
  setTimesheet,
  destroyTimesheet,
  roles,
  current_user
}) => (
  <Row noGutters>
    { roles.timesheet.update && (current_user.id === row.original.user_id || current_user.manager) && (
      <Col>
        <button
          style={{ border: 'none', background: 'transparent', outline: 'none' }}
          type="button"
          className="lnr lnr-pencil lnr--hover-blue"
          onClick={() => { setTimesheet('editable', row.original) }}
        />
      </Col>
    )}
    { roles.timesheet.destroy && current_user.id === row.original.user_id && (
      <Col>
        <button
          style={{ border: 'none', background: 'transparent', outline: 'none' }}
          type="button"
          className="lnr lnr-trash2 lnr--hover-blue"
          onClick={() => {
            if (confirm('Are you sure you want to delete this timesheet?')) {
              destroyTimesheet(row.original.path)
            }
          }}
        />
      </Col>
    )}
  </Row>
)

class TicketTimesheets extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      editableTimesheet: null,
      viewableTimesheet: null,
      allTimesheets: null,
      flash: null,
      users: {}
    }
  }

  componentDidMount = () => {
    const { paths } = this.props

    this.uniqueInputId = _.uniqueId()
    const timesheetPaths = ['serviceGroups']

    // loop through the  'itemsToRequest' and makes a request
    // to its index page(gathering all records)
    _.map(
      _.filter(paths, path => _.includes(timesheetPaths, path.name)),
      item => this.requestItems(item)
    )
  }

  componentWillReceiveProps (newProps) {
    const { timesheets } = newProps

    if (timesheets === undefined) { return }

    const timesheetUserIds = _.map(timesheets, propTimesheet => propTimesheet.user_id)
    const uniqueTimesheetUserIds = _.uniq(timesheetUserIds)

    cloudhelpGet('/api/users', { user_ids: uniqueTimesheetUserIds })
      .then((response) => {
        const userObject = {}
        _.each(response.data, user => (userObject[user.id] = user.name))

        this.setState({ users: userObject })
      })
  }

  setTimesheet = (type, timesheet) => {
    this.setState({ [`${type}Timesheet`]: timesheet })
  }

  showAllTimesheets = () => {
    const { timesheets } = this.props

    this.setState({
      allTimesheets: timesheets
    })
  }

  requestItems = (type) => {
    cloudhelpGet(type.path)
      .then((response) => {
        this.setState({
          [type.name]: response.data
        })
      })
  }

  decorateTimesheet = (timesheet) => {
    const { href } = this.props
    const { users } = this.state

    const workRole = timesheet.work_role_name || 'N/A'
    const workType = timesheet.work_type_name || 'N/A'

    const decoratedTimesheet = Object.assign({}, timesheet, {
      workRole,
      workType,
      userName: users[timesheet.user_id],
      href,
      service_group_id: timesheet.service_group_id,
      description: timesheet.description
    })

    return decoratedTimesheet
  }

  destroyTimesheet = (destroyTimesheetPath) => {
    const { gatherTimesheets } = this.props

    cloudhelpDelete(destroyTimesheetPath)
      .then((result) => {
        this.setState({
          flash: result.data
        })
        gatherTimesheets()
      })
      .catch((error) => {
        this.setState({
          flash: {
            error: error.data.error
          }
        })
      })
  }

  formatStringFromObject (object) {
    return JSON.stringify(object).replace(/\\n/g, ' ').slice(1, -1)
  }

  render () {
    const {
      setTimesheet,
      destroyTimesheet,
      formatStringFromObject,
      showAllTimesheets
    } = this

    const {
      editableTimesheet,
      viewableTimesheet,
      allTimesheets,
      flash
    } = this.state

    const {
      hidden,
      timesheets,
      loading,
      ticket,
      roles,
      current_user,
      title,
      serviceGroups,
      hasManagedServiceGroup,
      href,
      ticket_statuses,
      statusesRootIds,
      ticketCreatedAt
    } = this.props

    if (hidden) {
      return null
    }

    const data = timesheets && (_.map(timesheets, timesheet => this.decorateTimesheet(timesheet)))

    const columns = [
      { text: 'Start', accessor: 'start_time', Cell: row => (moment(row.value).format('DD MMM YYYY, HH:mmA')) },
      { text: 'End', accessor: 'end_time', Cell: row => (moment(row.value).format('DD MMM YYYY, HH:mmA')) },
      {
        text: 'User',
        accessor: 'userName',
        Cell: row => (
          <span style={{ color: '#00BAEA' }}>
            {row.value}
          </span>
        )
      },
      {
        text: 'Chargeable?', accessor: 'chargeable', maxWidth: 50, Cell: row => (row.value ? 'Yes' : 'No')
      },
      {
        text: 'Details',
        accessor: 'description',
        Cell: row => (
          <span
            style={{ cursor: 'pointer', color: '#00baea' }}
            onClick={() => { setTimesheet('viewable', row.original) }}
          >
            {formatStringFromObject(row.original.description)}
          </span>
        )
      },
      { text: 'Time Spent', accessor: 'time_spent' },
      { text: 'Work Type', accessor: 'workType' },
      { text: 'Work Role', accessor: 'workRole' }
    ]

    if (roles.timesheet.update && roles.timesheet.destroy && href === null) {
      columns.push(
        {
          text: 'Actions',
          accessor: '',
          Cell: row => (
            <ActionsCell
              ticketId={ticket.id}
              roles={roles}
              setTimesheet={setTimesheet}
              destroyTimesheet={destroyTimesheet}
              row={row}
              current_user={current_user}
            />
          )
        }
      )
    }

    return (
      <React.Fragment>
        {_.some(flash) && (
          <div>
            {_.map(flash, (message, type) => (
              <Alert alertType={type}>
                {message}
              </Alert>
            ))}
          </div>
        )}

        <Card padding="none">
          <ContentSectionBlock
            title={title}
            actions={timesheets && [
              {
                onClick: () => showAllTimesheets(),
                text: 'All Timesheets'
              }
            ]}
          >
            <Table
              data={data}
              loading={loading}
              columns={columns}
              defaultPageSize={5}
              localStoragePrefix="TicketTimesheets"
            />
          </ContentSectionBlock>
        </Card>

        { (editableTimesheet || viewableTimesheet) && (
          <TimesheetModal
            open
            ticketId={ticket.id}
            regionId={ticket.region_id}
            editableTimesheet={!!editableTimesheet}
            viewableTimesheet={!!viewableTimesheet}
            title={editableTimesheet ? 'Edit Ticket Timesheet' : 'Ticket Timesheet Summary'}
            url={editableTimesheet ? editableTimesheet.path : null}
            method={editableTimesheet ? 'patch' : null}
            timesheet={editableTimesheet || viewableTimesheet}
            serviceGroups={serviceGroups}
            hasManagedServiceGroup={hasManagedServiceGroup}
            onClose={() => {
              editableTimesheet ? this.setTimesheet('editable', null) : this.setTimesheet('viewable', null)
            }}
            modalOpen
            ticketStatuses={ticket_statuses}
            statusesRootIds={statusesRootIds}
            ticketCreatedAt={ticketCreatedAt}
          />
        )}

        { allTimesheets && (
          <AllTimesheetsModal
            modalOpen
            onClose={() => {
              this.setState({ allTimesheets: null })
            }}
            timesheets={allTimesheets}
          />
        )}
      </React.Fragment>
    )
  }
}

TicketTimesheets.propTypes = {
  hidden: PropTypes.bool,
  loading: PropTypes.bool,
  timesheets: PropTypes.array,
  href: PropTypes.string,
  gatherTimesheets: PropTypes.func.isRequired
}

TicketTimesheets.defaultProps = {
  hidden: false,
  loading: false,
  href: null
}

export default TicketTimesheets
